<div class="tooltip-container">
  <div class="tooltip-container__label">{{ 'new_feature_tooltip.NEW' | translate }}</div>
  <div class="tooltip-container__header">{{ tooltipHeader | translate }}</div>
  <div class="tooltip-container__content">
    {{ tooltipTxt | translate }}
  </div>
  <div class="tooltip-container__btn-container">
    <div (click)="dismissPopover()" class="tooltip-container__btn">{{ 'new_feature_tooltip.Gotit' | translate }}</div>
  </div>
</div>
